import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { TabsCoursesProps } from ".";
import RenderCoursesMobile from "../../../courses/components/RenderCoursesMobile";
import SummariesTab from "screens/BySummary/components/SummariesTab";

import "./stylesMobile.scss";
import SubscriptionPopup from "common/components/SubscriptionPopup";
import { setSimpleField } from "store/users/slice";
import { useTypedDispatch, useTypedSelector } from "store";

const TabsCoursesMobile = ({
  RenderComponent,
  dataAllCourses,
  onSelect,
  searchRes,
  onPressItem,
  onPressTricksPlay,
  onPressHandPlay,
  onPressDefLeadPlay,
  onPressDeffensePlay,
  onPressMiniBridge,
  search,
  listTitle,
  keyTab,
  listKeys,
  type
}: TabsCoursesProps) => {
  const { blockMixCourses } = useTypedSelector((store) => store.user);
  const dispatch = useTypedDispatch();

  return (
    <div
      className={`tab-courses-mobile ${search ? "search-mode-active" : ""} ${
        listKeys?.length >= 6 ? "tab-courses-mobile-more-6" : ""
      } ${type === "deffense_deflead" ? "tab-courses-mobile-deffense-deflead" : ""}`}>
      <Tabs defaultActiveKey="home" className="mb-3" onSelect={onSelect} activeKey={keyTab}>
        {listKeys &&
          listKeys.map((val: any, index) => {
            let resArr: any[] = [];
            const searchData: any[] = [];
            let handlePress = undefined;
            if (type !== "bidding") {
              switch (val) {
                case "handPlay":
                  handlePress = onPressHandPlay;
                  if (dataAllCourses[val]?.length) {
                    dataAllCourses[val]?.forEach((val: any) => {
                      if (val && val?.length) {
                        val?.forEach((item: any) => {
                          if (item) {
                            resArr.push({
                              ...item,
                              Id_Course: item?.Data?.Id_Category,
                              CourseKey: item?.Data?.CategoryName,
                              Name: `${item?.Data?.CatTitle1} ${item?.Data?.CatTitle2}`
                            });
                          }
                        });
                      }
                    });
                    if (searchRes?.length) {
                      searchRes.forEach((val: any) => {
                        searchData.push({
                          ...val,
                          Id_Course: val?.Id_Category,
                          CourseKey: val?.CategoryName,
                          Name: `${val?.CatTitle1} ${val?.CatTitle2}`
                        });
                      });
                    }
                  }
                  break;
                case "tricks":
                  handlePress = onPressTricksPlay;
                  if (dataAllCourses[val]?.length) {
                    dataAllCourses[val]?.forEach((val: any) => {
                      resArr.push({
                        ...val,
                        Id_Course: val?.CourseId,
                        CourseKey: val?.Title1,
                        Name: `${val?.Title1} ${val?.Title2}`
                      });
                    });
                  }
                  if (searchRes?.length) {
                    searchRes.forEach((val: any) => {
                      searchData.push({
                        ...val,
                        Id_Course: val?.CourseId,
                        CourseKey: val?.Title1,
                        Name: `${val?.Title1} ${val?.Title2}`
                      });
                    });
                  }
                  break;
                case "deffense":
                  handlePress = onPressDeffensePlay;
                  if (dataAllCourses[val]?.length) {
                    dataAllCourses[val]?.forEach((item: any) => {
                      if (Array.isArray(item)) {
                        item.forEach((itemVal: any) => {
                          if (itemVal?.Data?.Id_Category) {
                            resArr.push({
                              ...itemVal,
                              Id_Course: itemVal?.Data?.Id_Category,
                              CourseKey: itemVal?.Data?.CourseTitle,
                              Name: `${itemVal?.Data?.CatTitle1} ${itemVal?.Data?.CatTitle2}`
                            });
                          }
                        });
                      }
                    });
                  }
                  if (searchRes?.length) {
                    searchRes.forEach((val: any) => {
                      if (val?.Data?.Id_Category) {
                        searchData.push({
                          ...val,
                          Id_Course: val?.Data?.Id_Category,
                          CourseKey: val?.Data?.CourseTitle,
                          Name: `${val?.Data?.CatTitle1} ${val?.Data?.CatTitle2}`
                        });
                      }
                    });
                  }
                  break;
                case "defLead":
                  handlePress = onPressDefLeadPlay;
                  if (dataAllCourses[val]?.length) {
                    dataAllCourses[val]?.forEach((item: any) => {
                      if (item?.Data?.CourseId) {
                        resArr.push({
                          ...item,
                          Id_Course: item?.Data?.CourseId,
                          CourseKey: item?.Data?.CourseTitle,
                          Name: item?.Data?.Title
                        });
                      }
                    });
                  }
                  if (searchRes?.length) {
                    searchRes.forEach((val: any) => {
                      if (val?.Data?.CourseId) {
                        searchData.push({
                          ...val,
                          Id_Course: val?.Data?.CourseId,
                          CourseKey: val?.Data?.CourseTitle,
                          Name: val?.Data?.Title
                        });
                      }
                    });
                  }
                  break;
                case "miniBridge":
                  handlePress = onPressMiniBridge;
                  if (dataAllCourses[val]?.length) {
                    dataAllCourses[val]?.forEach((val: any) => {
                      if (val && val?.length) {
                        val?.forEach((item: any) => {
                          if (item) {
                            resArr.push({
                              ...item,
                              Id_Course: item?.Data?.Id_Category,
                              CourseKey: item?.Data?.CategoryName,
                              Name: `${item?.Data?.CatTitle1} ${item?.Data?.CatTitle2}`
                            });
                          }
                        });
                      }
                    });
                    if (searchRes?.length) {
                      searchRes.forEach((val: any) => {
                        searchData.push({
                          ...val,
                          Id_Course: val?.Id_Category,
                          CourseKey: val?.CategoryName,
                          Name: `${val?.CatTitle1} ${val?.CatTitle2}`
                        });
                      });
                    }
                  }
                  break;
                default:
                  resArr = dataAllCourses[val];
              }
            }

            return (
              <Tab eventKey={val} title={listTitle[val]} key={val}>
                {type === "bidding" && val === "summary" && (
                  <SummariesTab
                    isFirstTab={index === 0 ? true : false}
                    data={dataAllCourses[val]}
                    searchData={searchRes}
                    searchText={search}
                    valKey={val}
                  />
                )}
                {type === "bidding" && val !== "summary" && (
                  <RenderComponent
                    isFirstTab={index === 0 ? true : false}
                    data={dataAllCourses[val]}
                    onPressItem={onPressItem}
                    searchData={searchRes}
                    searchText={search}
                    valKey={val}
                    type="bidding"
                  />
                )}
                {type !== "bidding" && val !== "miniBridge" && (
                  <RenderCoursesMobile
                    isFirstTab={index === 0 ? true : false}
                    data={resArr}
                    onPressItem={handlePress}
                    searchData={searchData}
                    searchText={search}
                    type={val === "handPlay" ? "hand_play" : val === "defLead" ? "def_lead" : val}
                  />
                )}
                {type !== "bidding" && val === "miniBridge" && (
                  <RenderCoursesMobile
                    isFirstTab={index === 0 ? true : false}
                    data={resArr}
                    onPressItem={handlePress}
                    searchData={searchData}
                    searchText={search}
                    type="mini_bridge"
                  />
                )}
              </Tab>
            );
          })}
      </Tabs>
      <SubscriptionPopup
        modalHeight="calc(100vh - 100px)"
        show={blockMixCourses}
        onHide={() => {
          dispatch(
            setSimpleField({
              type: "blockMixCourses",
              value: false
            })
          );
        }}
      />
    </div>
  );
};

export default TabsCoursesMobile;
